import { IonItem, IonLabel, IonList } from "@ionic/react";
import { useCallback, useContext } from "react";
import { useIntl } from "react-intl";

import { RichTextareaContext } from "@components/fields/RichTextareaProvider";
import { MessageTemplateMergeTagEnum } from "@typing/Enums";

type Props = {
  onSelect: () => void;
};

const RichTextareaMergeTagsSelect = ({ onSelect }: Props) => {
  const intl = useIntl();

  const { setInsertContent } = useContext(RichTextareaContext);

  const options = Object.values(MessageTemplateMergeTagEnum).map(replacement => ({
    label: intl.formatMessage({ id: `pages.expert.sharableUrls.mergeTags.${replacement}` }),
    value: replacement
  }));

  const handleSelect = useCallback(
    (value: string) => {
      setInsertContent(value);
      onSelect();
    },
    [onSelect, setInsertContent]
  );

  return (
    <IonList className="ion-margin-top ion-no-padding">
      {options.map(option => (
        <IonItem button color="primary-50" key={option.label} lines="full" onClick={() => handleSelect(option.value)}>
          <IonLabel>{option.label}</IonLabel>
        </IonItem>
      ))}
    </IonList>
  );
};

export default RichTextareaMergeTagsSelect;
